import {process} from "@progress/kendo-data-query";
import {useEffect, useState} from "react";
import useFetch from "../../tools/UseFetch";
import config from "../../config/config.json";

import TmsInGrid from "./TmsInGrid";
import Waiting from "../waiting/Waiting";
import useClientStore from "../../stores/ClientStore";
import useProjectStore from "../../stores/ProjectStore";
import useTmsStore from "../../stores/TmsStore";
import TmsEdit from "./TmsEdit";


const Tms = props => {

    const {selectedClient} = useClientStore((state) => ({selectedClient: state.selectedClient}))
    const {selectedProject} = useProjectStore((state) => ({selectedProject: state.selectedItem}))

    const initialDataState = {
        take: 100,
        skip: 0,
        filter: {
            logic: "or",
            filters: [
                { field: "ProjectID", operator: "eq", value: selectedProject.ID },
            ]
        },
        sort: [
            { field: "Date", dir: "desc" }
        ]
    };

    const [dataState, setDataState] = useState(initialDataState);

    const data = useTmsStore(state => state.tms)
    const isLoading = useTmsStore(state => state.isLoading)
    const loadTmsForClient = useTmsStore(state => state.loadTmsForClient)
    const addNew = useTmsStore(state => state.addNew)
    const saveNew = useTmsStore(state => state.saveNew)
    const saveItem = useTmsStore(state => state.saveItem)
    const refreshData = useTmsStore(state => state.refreshData)


    const { data:workTypes, isPending:workType_isPending, error:workType_error} = useFetch(config.API_URL + 'lists/worktype/', 1)
    const { data:authors, isPending:authors_isPending, error:authors_error} = useFetch(config.API_URL + 'user/authors/', 1)
    const { data:projects, isPending:projects_isPending, error:projects_error} = useFetch(config.API_URL + 'project/for_lists', 1)
    const { data:actual_user, isPending:actual_user_isPending, error:actual_user_error} = useFetch(config.API_URL + 'user/get_own_user', 1)


    const [filterSelectedPeriod, setFilterSelectedPeriod] = useState({value:{text:"tento měsíc", id:3}})
    const [showFilter, setShowFilter] = useState(false)
    const [filterOnlyProject, setFilterOnlyProject] = useState(true)
    const [filterOnlyMine, setFilterOnlyMine] = useState(true)
    const [filterText, setFilterText] = useState("")


    useEffect(() => {
        console.log("selected client - ", selectedClient)
        loadTmsForClient(selectedClient.ID)

        if (props.openNew && actual_user) {
            props.setOpenNew(false)
            newTms()
        }

    },[actual_user])

    // useEffect(()=>{
    //     console.log("filter effect")
    //     let newFilterText = ""
    //     let newDataState = {
    //         take: 1000,
    //         skip: 0,
    //         filter: {
    //             logic: "or",
    //             filters: [
    //                 // { field: "ProjectID", operator: "eq", value: selectedProject.ID },
    //             ],
    //             sort: [
    //                 { field: "Date", dir: "desc" }
    //             ]
    //         }
    //     }
    //     // debugger
    //     if (filterOnlyMine) {
    //         newFilterText += "pouze moje, "
    //     } else {
    //         newFilterText += "kdokoli, "
    //     }
    //
    //     if (filterOnlyProject) {
    //         newFilterText += "pouze projekt, "
    //         newDataState.filter.filters.push({field: "ProjectID", value: selectedProject.ID, operator: "eq"})
    //     } else {
    //         newFilterText += "klient vše, "
    //     }
    //
    //     newFilterText += filterSelectedPeriod.value.text
    //
    //     setFilterText(newFilterText)
    //     setDataState(newDataState)
    //
    // },[filterOnlyProject, filterOnlyMine, filterSelectedPeriod])


    const filters = [
        {text:"nefakturováno", id:1},
        {text:"kdykoli", id:2},
        {text:"tento měsíc", id:3},
        {text:"minulý měsíc", id:4},
    ]

    const ChangeFilter = (event) => {
        setFilterSelectedPeriod({value: event.target.value,});

        let newDataState = {}
        if (event.target.value.id < 10) {
            newDataState = {
                take: 50,
                skip: 0,
                filter: {
                    logic: "or",
                    filters: [
                        { field: "ProjectID", operator: "eq", value: selectedProject.ID },
                    ]
                }
            }}
        else {
            newDataState = {
                take: 50,
                skip: 0,
            }
        }
        setDataState(newDataState)
        }


    // ********************************* helper data  *********************************

    const [editMode, setEditMode] = useState(false)
    const [editItem, setEditItem] = useState(null);


    // ************************************** EDIT *************************************

    const enterEdit = (dataItem) => {
        setEditItem(dataItem)
        setEditMode(true)
    };

    const handleCancelEdit = (dataItem) => {
        setEditMode(false);
        refreshData()
    };

    const handleSubmit = (dataItem) => {
        // debugger
        if (dataItem.ID === undefined || dataItem.ID === null) {
            saveNew(dataItem)
        }
        else {
            saveItem(dataItem)
        }
        setEditMode(false);
        refreshData()
    };


    // ************************************** NEW *************************************

    const newTms = () => {
        if (!actual_user) return

        const newItem = addNew()
        newItem.ProjectID = selectedProject

        const now = new Date()
        newItem.Date = new Date(now.getFullYear(), now.getMonth(), now.getDate())

        newItem.AuthorID = actual_user.ID

        newItem.TimeSpentIn = 0

        setEditItem(newItem)
        setEditMode(true)
    }

    const closeEdit = () => {
        // setRefresh(Date.now())
        setEditMode(false)
    }

    return(
        <>

            {isLoading && <Waiting />}

            {data && authors && actual_user && <>

                {editMode && <TmsEdit close={closeEdit} project={selectedProject}
                                      projects={projects}
                                      authors={authors}
                                      workTypes={workTypes}
                                      // currencies={currency}
                                      cancelEdit={handleCancelEdit}
                                      onSubmit={handleSubmit}
                                      item={editItem}
                />}

                {!editMode && <div className="tms">




                    {/*<div className="page-header">*/}
                    {/*/!*<div className="separator"></div>*!/*/}
                    {/*    <div className="section">*/}
                    {/*        <h2>{selectedProject.Name}</h2>*/}
                    {/*        /!*<Checkbox defaultChecked={true} label={"Zobrazit pouze projekt"} />*!/*/}
                    {/*        /!*<div className="space"></div>*!/*/}

                    {/*        <div className="tms-add-button">*/}
                    {/*            <Button*/}
                    {/*                themeColor={"warning"}*/}
                    {/*                size={"large"}*/}
                    {/*                onClick={newTms}*/}
                    {/*                style={{*/}
                    {/*                    width: "100%",*/}
                    {/*                    height: "100%"*/}
                    {/*                }}*/}
                    {/*            >Nový</Button>*/}
                    {/*        </div>*/}

                    {/*        <div className="space"></div>*/}

                    {/*    </div>*/}

                    {/*    <div className="section">*/}
                    {/*        <div className="filter-header" onClick={() => {setShowFilter(!showFilter)}}>*/}
                    {/*            /!*<h2 className="filter-caption">Filtr:</h2>*!/*/}
                    {/*            <span className="filter-text">{filterText}</span>*/}
                    {/*        </div>*/}

                    {/*        /!*<Checkbox defaultChecked={true} label={"Zobrazit pouze projekt"} />*!/*/}
                    {/*        /!*<div className="space"></div>*!/*/}
                    {/*        {showFilter &&*/}
                    {/*            <div className="filter-body">*/}
                    {/*                <div className="filter-item">*/}
                    {/*                    <Checkbox size={"large"} value={filterOnlyProject} onChange={()=>{setFilterOnlyProject(!filterOnlyProject)}} label={"Zobrazit pouze projekt"} />*/}
                    {/*                </div>*/}
                    {/*                <div className="filter-item">*/}
                    {/*                    <Checkbox size={"large"} value={filterOnlyMine} onChange={()=>{setFilterOnlyMine(!filterOnlyMine)}} label={"Zobrazit pouze moje"} />*/}
                    {/*                </div>*/}
                    {/*                <div className="filter-item">*/}
                    {/*                    <DropDownList*/}
                    {/*                        data={filters}*/}
                    {/*                        size={"large"}*/}
                    {/*                        textField={"text"}*/}
                    {/*                        dataItemKey={"id"}*/}
                    {/*                        value={filterSelectedPeriod.value}*/}
                    {/*                        // fillMode={"flat"}*/}
                    {/*                        style={{*/}
                    {/*                            width: "90%",*/}
                    {/*                        }}*/}
                    {/*                        onChange={(e) => setFilterSelectedPeriod({value: e.target.value})}*/}
                    {/*                    />*/}
                    {/*                </div>*/}

                    {/*            </div>*/}
                    {/*        }*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    <div className="space"></div>

                    <div className="page-body">

                        {/*{showFilter && <>*/}
                        {/*    <div className="tms-filter-space"></div>*/}
                        {/*</>}*/}

                        {process(data, dataState).data.map(record => (
                            // <div key={record.ID}>{record.text}</div>
                            <TmsInGrid key={record.ID} id={record.ID} record={record} authors={authors} edit={enterEdit} />
                        ))}

                    </div>

                    <div className="tms-add-new-button" onClick={newTms}>+
                        {/*<ion-icon name="add-outline"></ion-icon>*/}
                    </div>

                </div>}

            </>}
        </>
    )
}

export default Tms
